/** Render text along a path in a Canvas
 *	Adds extra functionality to the CanvasRenderingContext2D by extending its prototype.
 *	Extent the global object with options:
 *		- textOverflow {undefined|visible|ellipsis|string} the text to use on overflow, default "" (hidden)
 *		- textJustify {undefined|boolean} used to justify text (otherwise use textAlign), default false
 * Code taken from: https://github.com/Viglino/Canvas-TextPath
 *
 * @param {string} text the text to render
 * @param {Array<Number>} path an array of coordinates as support for the text (ie. [x1,y1,x2,y2,...]
 */
// TODO: This code is outdated, it needs to be replaced by a fabricjs implementation
(function () {
    /* Add new properties on CanvasRenderingContext2D */
    CanvasRenderingContext2D.prototype.textOverflow = '';
    CanvasRenderingContext2D.prototype.textJustify = false;

    var state = [];
    var save = CanvasRenderingContext2D.prototype.save;

    function calculateTextWidth(ctx, text, tracking) {
        let textWidth = 0;
        for (let n = text.length - 1; n >= 0; --n) {
            if (n == 0) {
                //we won't add the char spacing on the last for iteration, this prevents having a blank space at the end of a word
                tracking = 0;
            }
            const w = _measureTextOpentype.call(ctx, text[n], undefined, undefined, tracking).width;
            textWidth += w;
        }
        return textWidth;
    }

    /**
     * This method draws an ellipse applying a correction to the start and end angles.
     * The parametric equation with theta:
     *      x = a * cos(theta)
     *      y = b * cos(theta)
     * Is only valid for circles. If we use theta to set the start and end angles of the ellipse
     *  they will vary with the ellipse size. We have to calculate the angle phi for the ellipse instead.
     * See: http://www.petercollingridge.co.uk/tutorials/computational-geometry/finding-angle-around-ellipse/
     * @param {CanvasRenderingContext2D} ctx canvas context to use to draw the ellipse
     * @param {Number} cx ellipse center X
     * @param {Number} cy ellipse center Y
     * @param {Number} w ellipse horizontal radius
     * @param {Number} h ellipse vertical radius
     * @param {Number} r rotation
     * @param {Number} sa ellipse start angle (radians)
     * @param {Numebr} ea ellipse end angle (radians)
     */
    function correctEllipse(ctx, cx, cy, w, h, r, sa, ea, anticlockwise) {
        sa = ctx.atanTan(sa, w, h);
        ea = ctx.atanTan(ea, w, h);
        ctx.ellipse(cx, cy, w, h, r, sa, ea, anticlockwise);
    }

    CanvasRenderingContext2D.prototype.save = function () {
        state.push({ textOverflow: this.textOverflow, textJustify: this.textJustify });
        save.call(this);
    };

    var restore = CanvasRenderingContext2D.prototype.restore;
    CanvasRenderingContext2D.prototype.restore = function () {
        restore.call(this);
        var s = state.pop();
        this.textOverflow = s.textOverflow;
        this.textJustify = s.textJustify;
    };

    /* textPath function */
    CanvasRenderingContext2D.prototype.textPath = function (text, properties) {
        const savedFontSize = Number(window._getExactFontSizeOpentype.call(this));
        let fontSize = savedFontSize < this.minSizePx ? this.minSizePx : savedFontSize;

        if (this.pathWidth > 0) {
            // Path drawing
            this.save();

            // Draw the inactive arc
            this.beginPath();
            this.strokeStyle = 'rgba(0, 0, 0, 0.3)';
            this.lineWidth = this.pathWidth;
            correctEllipse(
                this,
                0,
                0,
                this.a,
                this.b,
                0,
                fabric.util.degreesToRadians(this.endAngle - 90),
                fabric.util.degreesToRadians(this.startAngle - 90),
                this.convex
            );
            this.stroke();

            // Draw the path where the text will be drawn in a different color
            this.beginPath();
            this.strokeStyle = this.pathColor;
            this.lineWidth = this.pathWidth;
            correctEllipse(
                this,
                0,
                0,
                this.a,
                this.b,
                0,
                fabric.util.degreesToRadians(this.startAngle - 90),
                fabric.util.degreesToRadians(this.endAngle - 90),
                this.convex
            );
            this.stroke();

            this.restore();
        }

        var d = this.pathLength;
        if (d < 0) return;

        // Remove char for overflow
        if (this.textOverflow != 'visible') {
            const textWidth = calculateTextWidth(this, text, this.tracking);

            if (textWidth > this.maxTextArcLength) {
                fontSize = Math.min(this.maxSizePx, this.maxSizePx * (this.maxTextArcLength / textWidth));

                if (fontSize > this.minSizePx) {
                    _setFontSizeOpentype.call(this, fontSize);
                } else {
                    fontSize = this.minSizePx;
                    _setFontSizeOpentype.call(this, fontSize);
                    // If the text goes over the path length, apply overflow
                    const overflow = this.textOverflow == 'ellipsis' ? '\u2026' : this.textOverflow || '';

                    do {
                        // Remove characters until the text fits in the path
                        text = text.slice(0, -1);
                    } while (text?.length && this.maxTextArcLength < calculateTextWidth(this, text, this.tracking));
                    text += overflow;
                }
            }
        }

        // Calculate start point
        var start = -d / 4;
        var extraSpace = 0;
        var justifyNeeded = false;
        var singleWord = false;

        // Add the offset from the starting angle
        start += this.startArcOffset;

        // Justify
        if (this.textJustify) {
            // Justify has the same alignment as left so 'start' is already right.
            // Calculate the extra space needed to justify the text
            var justifyWidth = this.maxTextArcLength;
            const textWidth = calculateTextWidth(this, text);

            if (justifyWidth && textWidth < justifyWidth) {
                justifyNeeded = true;
                var extra = justifyWidth - textWidth;
                /*var spacesGroups = text.match(/\s+/g);
                if (spacesGroups) {
                    extraSpace = extra / spacesGroups.length;
                } else {
                    singleWord = true;
                    extraSpace = extra / (text.length - 1);
                }*/
                singleWord = true;
                extraSpace = extra / (text.length - 1);
            }
        }
        // Text align
        else {
            const textWidth = calculateTextWidth(this, text, this.tracking);

            if (this.textAlign === 'right') {
                if (!this.convex) {
                    // Align text to the end angle
                    start = start - this.maxTextArcLength + textWidth;
                } else {
                    start = start + this.maxTextArcLength - textWidth;
                }
            } else if (this.textAlign === 'center') {
                if (!this.convex) {
                    start -= (this.maxTextArcLength - textWidth) / 2;
                } else {
                    start += this.maxTextArcLength / 2;
                    start -= textWidth / 2;
                }
            }
        }
        start = this.wrapDistanceAroundPath(start, d);

        const pathsData = [];
        // Do the rendering
        let spaceFound = false;
        for (let t = 0; t < text.length; ++t) {
            let extraAngle = 0;
            const letter = text[t];
            const metrics = _measureTextOpentype.call(this, letter, undefined, undefined, this.tracking);
            const letterWidth = metrics.width;

            if (this.convex && t === 0) {
                start = this.wrapDistanceAroundPath(start, d);
            }

            if (justifyNeeded && (spaceFound || (singleWord && t !== 0))) {
                start = this.convex ? start + extraSpace : start - extraSpace;
                spaceFound = false;
            }

            /**
             * Check if this is an space character, in justify mode we
             * have to expand the spaces
             */
            if (justifyNeeded && justifyWidth && /[ \t\r]/.test(letter)) {
                spaceFound = true;
            }

            // Go around the path if we go over the max length
            var d1 = this.wrapDistanceAroundPath(start, d - 0.00001);

            // Get the point in the path at the current length
            const point = properties.getPointAtLength(d1);

            // Get the angle in a point half way the character
            const letterWidthValue = this.convex ? letterWidth : -1 * letterWidth;
            var d1a = this.wrapDistanceAroundPath(d1 + letterWidthValue / 2, d);
            var d2a = this.wrapDistanceAroundPath(d1 + letterWidthValue / 2 + 0.00001, d);

            var p1a = properties.getPointAtLength(d1a);
            var p2a = properties.getPointAtLength(d2a);
            var angle = Math.atan2(p1a.y - p2a.y, p1a.x - p2a.x);

            // Draw
            this.save();
            this.textAlign = 'center';
            this.translate(point.x, point.y);
            this.rotate(angle);

            if (this.convex) {
                extraAngle = Math.PI;
                this.rotate(extraAngle);
            }

            _fillTextOpentype.call(this, letter, 0, 0);
            pathsData.push({
                path: this.lastDrawnData.paths[0],
                x: point.x,
                y: point.y,
                angle: angle + extraAngle
            });

            this.restore();
            start = this.convex ? start + letterWidth : start - letterWidth;
        }

        return { pathsData, fontSize };
    };
})();
